/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedDetailPayments_viewer$ref = any;
type PdpSharedDetailShipping_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespShippingReturns_viewer$ref: FragmentReference;
export type PdpRespShippingReturns_viewer = {|
  +isItemInvoiceEnabled: ?boolean,
  +$fragmentRefs: PdpSharedDetailShipping_viewer$ref & PdpSharedDetailPayments_viewer$ref,
  +$refType: PdpRespShippingReturns_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespShippingReturns_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailPayments_viewer",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "isItemInvoiceEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "INVOICE",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"INVOICE\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c6a7befc721458cc3fc62946bd7f9782';
module.exports = node;
